"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapEditorialCarousel = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
/**
 * Utility to filter carousel slides with thruthy data and map them to `ArticleBoxProps` type.
 * @returns Slides with thruthy data mapped to `ArticleBoxProps` type.
 */ const mapEditorialCarousel = (param)=>{
    let { slides } = param;
    return (slides !== null && slides !== void 0 ? slides : []).filter((slide)=>!!slide).filter((param)=>{
        let { editorialLink: { relativeUrl }, description, thumbnailUrl, title } = param;
        return !!relativeUrl && !!description && !!thumbnailUrl && !!title;
    }).map((param)=>{
        let { editorialLink: { relativeUrl }, description, themeTag, thumbnailUrl, title } = param;
        return {
            categoryTitle: themeTag,
            image: {
                alt: title,
                url: thumbnailUrl
            },
            introText: description,
            isVideoArticle: false,
            link: {
                relativeUrl,
                type: _editorialFetching.LinkType.EditorialArticle
            },
            title
        };
    });
};
exports.mapEditorialCarousel = mapEditorialCarousel;
